import React from 'react';
import { connect } from 'react-redux';
import Link from 'next/link';
import css from './Recommend.less';

const Recommend = props => {
  const { institution } = props;
  const { recommendList } = institution;
  if (recommendList.length <= 0) {
    return false;
  }
  return (
    <div className={css.contentMain}>
      <h2 className={`text-hidden-one ${css.title}`}>相关机构推荐</h2>
      <ul>
        {recommendList.map((item, index) => {
          return (
            <li
              className={css.item}
              key={item.id.toString()}
              style={{ display: index <= 4 ? 'block' : 'none' }}
            >
              <Link
                href={{
                  pathname: '/institution/[id]/',
                }}
                as={{
                  pathname: `/institution/${item.id}/`,
                }}
                passHref
              >
                <a>
                  <div
                    className={`bg-cover ${css.avatar}`}
                    style={{
                      backgroundImage: `url(${item.cover_url})`,
                    }}
                  >
                    {' '}
                  </div>
                  <div className={css.info}>
                    {item.total_score ? (
                      <p className={`dinMedium ${css.score}`}>
                        {item.total_score}
                      </p>
                    ) : null}
                    <p className={`text-hidden-one ${css.name}`}>{item.name}</p>
                  </div>
                </a>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default connect(({ institution }) => ({
  institution,
}))(Recommend);
